import { FileText, UploadCloud, Loader2, CheckCircle2, AlertCircle, Package } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { FileStatus } from './types'

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function formatDate(isoString: string): string {
  return new Date(isoString).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getStatusConfig(status: FileStatus): {
  label: string
  color: string
  icon: LucideIcon
} {
  const config: Record<FileStatus, { label: string; color: string; icon: LucideIcon }> = {
    idle: { label: 'Upload', color: 'bg-gray-100 text-gray-600', icon: FileText },
    uploading: { label: 'Upload läuft', color: 'bg-blue-100 text-blue-600', icon: UploadCloud },
    extracting: { label: 'Extrahierung', color: 'bg-yellow-100 text-yellow-600', icon: Loader2 },
    structure_ok: { label: 'Bereit', color: 'bg-green-100 text-green-600', icon: CheckCircle2 },
    entry_ok: { label: 'Einträge OK', color: 'bg-green-100 text-green-600', icon: CheckCircle2 },
    imported: { label: 'Importiert', color: 'bg-blue-100 text-blue-600', icon: Package },
    error: { label: 'Fehler', color: 'bg-red-100 text-red-600', icon: AlertCircle },
  }
  return config[status] || config.idle
}

export function confidenceColor(c: number | null): string {
  if (c == null) return 'bg-gray-100 text-gray-500'
  if (c >= 0.85) return 'bg-green-100 text-green-700'
  if (c >= 0.60) return 'bg-yellow-100 text-yellow-700'
  return 'bg-red-100 text-red-700'
}

export function confidenceLabel(c: number | null): string {
  if (c == null) return 'N/V'
  if (c >= 0.85) return 'Hoch'
  if (c >= 0.60) return 'Mittel'
  if (c >= 0.40) return 'Niedrig'
  return 'Sehr niedrig'
}
